import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { Link, useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';
import ExternalLink from 'components/Widgets/ExternalLink';
import StepTab from 'components/new_ui/Tabs/StepTab';
import { useContext } from 'components/Members/Programs/Views/Show/Context';
import { useContext as useUsersContext } from 'components/Users/Context';
import Info from 'components/Members/Programs/Widgets/Info/Index';
import Steps from 'components/Members/Programs/Widgets/Steps/Index';

import Alert from 'components/new_ui/Alerts/alert';

import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';

export default function Index({ showSteps, onNextStep }) {
  const { state } = useContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const wrapper = useRef(null);

  const { state: stateUser } = useUsersContext();

  const member = stateUser.user?.attributes?.specific;

  const homeContext = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Programs',
      path: routes.members.programs.index,
    },
    {
      name: 'New Program',
    },
  ];

  const saveForLaterProgram = () => {
    setLoading(true);

    axios
      .post(routes.api.programs.saveForLater(state.program.id))
      .then((_resp) => {
        setLoading(false);
        if (onNextStep !== undefined) {
          if (member && member.ai_enabled) {
            onNextStep('/members/home');
          } else {
            onNextStep(routes.members.programs.index);
          }
        } else if (stateUser.user.attributes.is_mobile_login) {
          navigate(routes.members.programs.new.webview);
        } else {
          navigate(routes.members.programs.index);
        }
      });
  };

  const startProgram = () => {
    setLoading(true);

    axios
      .post(routes.api.programs.start(state.program.id))
      .then((_resp) => {
        setLoading(false);
        if (onNextStep !== undefined) {
          onNextStep(routes.members.programs.show(state.program.id));
        } else if (stateUser.user.attributes.is_mobile_login) {
          navigate(routes.members.programs.new.webview);
        } else {
          navigate(routes.members.programs.show(state.program.id));
        }
      }).catch((error) => {
        setLoading(false);
        if (error.response.data.errors) {
          Alert({
            text: error.response.data.errors[0].title,
          });
        }
      });
  };

  return (
    <>
      {showSteps && (
      <StepTab
        total={3}
        current={3}
      />
      )}

      <div className="content">
        {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <section>
          <h1>{state.program.attributes.title}</h1>
        </section>

        <section ref={wrapper}>
          <Info program={state.program} />
          <Row className="mt-5">
            <Col lg={{ span: 8, offset: 2 }}>
              <h6 className="mb-3">Your Program</h6>

              <Steps steps={state.program.attributes.steps} readOnly />
            </Col>
          </Row>
          <div className="d-flex justify-content-end">
            {!stateUser.user.attributes.is_mobile_login && (
            <ExternalLink
              variant="link"
              href={routes.members.programs.download(state.program.id)}
            >
              Download Program
            </ExternalLink>
            )}
          </div>
        </section>

        <footer className="d-lg-flex flex-row-reverse">
          <div className="d-md-flex flex-lg-row-reverse mb-3 mb-lg-0 ms-lg-3">
            <div className="flex-grow-1 d-block d-md-inline-block mb-3 mb-md-0 ms-lg-3">
              <Button
                onClick={() => startProgram()}
                disabled={loading}
                className="w-100"
              >
                Start
              </Button>
            </div>

            <div className="flex-grow-1 d-block d-md-inline-block ms-0 ms-md-3">
              <Button
                variant="outline-primary"
                className="btn-reverse w-100"
                onClick={() => saveForLaterProgram()}
                disabled={loading}
              >
                Save
              </Button>
            </div>
          </div>

          <div className="flex-grow-1 d-md-flex">
            <Link
              to={routes.members.programs.new_ai.orderTopics(state.program.id)}
              className="btn btn-outline-primary d-block d-md-inline-block ms-0"
            >
              Previous
            </Link>
          </div>
        </footer>
      </div>

    </>
  );
}

Index.propTypes = {
  showSteps: PropTypes.bool,
  onNextStep: PropTypes.func,
};

Index.defaultProps = {
  showSteps: true,
  onNextStep: undefined,
};
